var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import ApiRequests from "../../../classes/http/ApiRequests";
import HttpRequests from "../../../classes/http/HttpRequests";
import Grid from '../../../components/UI/Grid/Grid';
import AppRoutes from '../../../config/appRoutes';
var MainStaticPagesList = /** @class */ (function (_super) {
    __extends(MainStaticPagesList, _super);
    function MainStaticPagesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'Име', key: 'bg_name', filter: false, sort: false },
            { name: 'Тип', key: 'page_type', filter: false, sort: false },
            { name: 'Slug', key: 'slug', filter: false, sort: false },
            { name: 'Позиция', key: 'position', filter: false, sort: false },
        ];
        _this.editProduct = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                _this.props.history.push(AppRoutes.editStaticPage.path.replace(':staticPageId', selectedId));
            }
        };
        _this.deleteRelatedCollection = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u0430?");
            if (ask) {
                _this.api.deleteMainStaticPage(selectedId)
                    .then(function (response) {
                    // Delete the item from the state of the parent component
                    _this.props.deleteItem(selectedId);
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.props.messages, 'Записът не бе изтрит. Моля, опитайте отново.', _this.props.history);
                });
            }
        };
        return _this;
    }
    MainStaticPagesList.prototype.render = function () {
        var gridData = this.props.gridData;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, total: 50, rows: 10, editAction: this.editProduct, deleteAction: this.deleteRelatedCollection }));
    };
    return MainStaticPagesList;
}(React.Component));
// @ts-ignore
export default withRouter(MainStaticPagesList);



//////////////////
// WEBPACK FOOTER
// ./src/components/MainStaticPages/MainStaticPagesList/MainStaticPagesList.tsx
// module id = 372
// module chunks = 0